import React from 'react';

function isDisabled(disabled) {
    if (disabled) {
        return true;
    } else {
        return false;
    }
}

const Select = ({options, defaultValue, classes, change, disabled}) => {
    return (
        options && options.length > 0 ? <select disabled={isDisabled(disabled)} className={classes} defaultValue="" onChange={change}>

            <option value="" disabled>{defaultValue}</option>

            {options.map((opt, i) => {
                return <option key={i} value={opt.child_id}>{opt.name}</option>
            })}
        </select> : ''
    );
}

export default Select;